import React, { Component, Fragment } from 'react'

import {
    Bricks,
    Cards,
    Carousel,
    ContactWithForm,
    CrossText,
    FullHeightImageWithText,
    GallerySection,
    ImageAndText,
    MadeBy,
    SectionMenu,
    SectionType,
    Separator,
    SimpleContact,
    SimpleFooter,
    SimpleHeader,
    SimpleText,
    SlimHeader,
    ParallaxSection,
    TabsSection,
    VideoBG
} from './sections/'

class Sections extends Component {
    coverWithSection(key, sectionType, sectionComponent) {
        return (
            <SectionType key={key} sectionType={sectionType}>
                {sectionComponent}
            </SectionType>    
        )
    }

    renderSections() {
        return (
            <Fragment>
                {this.props.sections.map((section, key) => {
                    const { content } = section
                    switch (section.type) {
                        case 'BRICKS':
                            return this.coverWithSection(key, section.sectionType, <Bricks data={content} css={section.class} />)
                        case 'CARDS':
                            return this.coverWithSection(key, section.sectionType, <Cards data={content} css={section.class} />)
                        case 'CONTACT_WITH_FORM':
                            return this.coverWithSection(key, section.sectionType, <ContactWithForm logoInverted={section.logoInverted} data={this.props.info} content={content} css={section.class} />)
                        case 'CROSS_TEXT':
                            return this.coverWithSection(key, section.sectionType, <CrossText data={content.parts} title={content.title} css={section.class} hasBackgrounds={section.hasBackground} />)
                        case 'FULL_HEIGHT_IMAGE_WITH_TEXT':
                            return <FullHeightImageWithText key={key} data={section} />
                        case 'GALLERY':
                            return this.coverWithSection(key, section.sectionType, <GallerySection title={section.title} content={content} css={section.class} />)
                        case 'IMAGE_AND_TEXT':
                            return this.coverWithSection(key, section.sectionType, <ImageAndText data={content} css={section.class} hasBackgrounds={section.hasBackground} />)
                        case 'MADE_BY':
                            return this.coverWithSection(key, section.sectionType, <MadeBy content={content} css={section.class} />)
                        case 'PARALLAX':
                            return <ParallaxSection key={key} data={content} image={content.image} height={200} css={section.class} />
                        case 'SECTION_MENU':
                            return <SectionMenu key={key} color={section.color} />
                        case 'SEPARATOR':
                            return this.coverWithSection(key, section.sectionType, <Separator data={section} />)    
                        case 'SIMPLE_CONTACT':
                            return this.coverWithSection(key, section.sectionType, <SimpleContact css={section.class} logoInverted={section.logoInverted} data={this.props.info} content={content} />)
                        case 'SIMPLE_FOOTER':
                            return this.coverWithSection(key, section.sectionType, <SimpleFooter css={section.class} logoInverted={section.logoInverted} info={this.props.info} />)
                        case 'SIMPLE_HEADER':
                            return <SimpleHeader key={key} info={this.props.info} />
                        case 'SIMPLE_TEXT':
                            return this.coverWithSection(key, section.sectionType, <SimpleText content={content} css={section.class} />)
                        case 'SLIM_HEADER':
                            return <SlimHeader key={key} theme={section.theme} />
                        case 'SLIDER':
                            return <Carousel key={key} slides={content.slides} css={section.class} />
                        case 'TABS':
                            return this.coverWithSection(key, section.sectionType, <TabsSection data={content.tabs} title={content.title} textTop={content.text_top} textBottom={content.text_bottom} css={section.class} />)
                        case 'VIDEO_BG':
                            return <VideoBG key={key} data={section} />
                        default:
                            return null
                    }
                })}
            </Fragment>
        )
    }

    render() {
        return <Fragment>{this.renderSections()}</Fragment>
    }
}

export default Sections


// WEBPACK FOOTER //
// ./src/components/Sections.js